import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const XmlFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "XmlFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.53 10.56a2 2 0 0 0-.12-.35s-.05-.08-.05-.08c-.06-.11-.13-.21-.22-.3l-7.48-7.49c-.09-.09-.19-.16-.3-.22s-.08 0-.08 0c-.08-.04-.17-.08-.26-.1h-9.71c-2.3 0-4.17 1.85-4.21 4.15v7.95H4.29c-1.03 0-1.87.84-1.87 1.87v6.55c0 1.03.84 1.87 1.87 1.87H7.1v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.81c0-.08 0-.16-.02-.24ZM8.94 21.82c.03.06.05.14.05.21 0 .19-.11.36-.27.44-.06.03-.14.05-.21.05-.19 0-.36-.11-.44-.27L7.1 20.3l-.97 1.95c-.08.16-.24.27-.42.27H5.7c-.08 0-.15-.02-.22-.05a.5.5 0 0 1-.22-.41c0-.09.02-.17.07-.25s1.27-2.58 1.27-2.58l-1.27-2.59a.49.49 0 1 1 .87-.44s.97 1.95.97 1.95l.97-1.95a.49.49 0 0 1 .88.44s-1.33 2.62-1.33 2.62l1.28 2.55Zm17.82 4.41c0 .77-.76.97-1.4.97H11.33c-.64 0-1.4-.17-1.4-.97v-1.84h11.22c1.03 0 1.87-.84 1.87-1.87v-6.55c0-1.03-.84-1.87-1.87-1.87H9.93V6.15c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.29 1.05 2.34 2.34 2.34h5.14zm-13.59-6.64c-.08.17-.24.29-.44.29s-.36-.12-.44-.29l-.46-.98v3.43a.49.49 0 0 1-.98 0v-5.58s-.01-.07-.01-.1a.501.501 0 0 1 .99-.11s.97 1.95.97 1.95l.97-1.95c.05-.23.25-.4.49-.4.27 0 .5.22.5.5 0 .04 0 .07-.01.11s0 5.6 0 5.6a.49.49 0 0 1-.98 0v-3.43l-.61.95Zm6.55 1.95a.49.49 0 0 1 0 .98h-2.76a.49.49 0 0 1-.49-.49v-5.56a.49.49 0 0 1 .98 0v5.11z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M4.14 17.86c-.63 0-1.14-.51-1.14-1.14V5.29C3 3.4 4.54 1.86 6.43 1.86h13.71c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H6.43c-.63 0-1.14.51-1.14 1.14v11.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.29 17.86c-.63 0-1.14-.51-1.14-1.14v-3.43h-5.71c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14ZM6.17 24.74l-3.12-4.39h2.86l1.72 2.72 1.68-2.72h2.75l-3.08 4.49 3.18 4.44H9.29l-1.78-2.7-1.78 2.7H2.99l3.16-4.55ZM12.94 20.35h2.07l2.6 3.71 2.6-3.71h2.07v8.94H20v-5.11l-2.26 2.86h-.25l-2.26-2.86v5.11h-2.29zM23.7 20.35h2.29v6.84h3.93v2.09H23.7z"
      })]
    })
  }));
};